import React, { createContext, useContext, useState, useLayoutEffect, useEffect, useCallback } from 'react';
import defaultUser from '../imgs/default.png';
const ThemeContext = createContext();
export const ThemeProvider = ({ children }) => {
  const [theme, setCurrentTheme] = useState(() => localStorage.getItem('theme') === 'light' ? 'light' : 'dark');
  const [profileImage, setProfileImage] = useState(defaultUser);
  useEffect(() => () => {
    if (profileImage.startsWith('blob:')) URL.revokeObjectURL(profileImage);
  }, [profileImage]);
  const setTheme = useCallback(value => {
    if (value === 'dark' || value === 'light') setCurrentTheme(value);
  }, []);
  useLayoutEffect(() => {
    document.body.classList.remove('theme-dark', 'theme-light', 'theme-ocean', 'theme-venom', 'theme-skyline');
    document.body.classList.add('theme-' + theme);
    document.documentElement.style.colorScheme = theme;
    document.documentElement.dataset.theme = theme;
    const browserTheme = document.querySelector('meta[name="theme-color"]');
    if (browserTheme) browserTheme.content = theme === 'light' ? '#f0f3f7' : '#1a1f36';
    localStorage.setItem('theme', theme);
  }, [theme]);
  return <ThemeContext.Provider value={{ theme, setTheme, profileImage, setProfileImage }}>{children}</ThemeContext.Provider>;
};
export const useThemeContext = () => useContext(ThemeContext);
